<!--<app-map-polygon [area]="area" [color]="color" [zoneStyle]="true" [boundToPoly]="true" *ngIf="area"></app-map-polygon>-->
<div class="toolbox" *ngIf="editMode">
    <button class="btn btn-icon btn-secondary btn-sm" [disabled]="!isDrawnEnd" (click)="handlerClearPoly()"><i
            class="icon-trash"></i>
    </button>
</div>
